import * as actionsCommon from '@/store/actions'
import {
  FETCH_DETACH_REASONS,
  FETCH_TIMESLOTS,
  GET_IS_LOADING_CALL_DRIVER,
  GET_IS_LOADING_TIMESLOTS,
  GET_PARKMAN_DETACH_REASONS,
  GET_PARKMAN_DIRECTION,
  GET_PARKMAN_TABLE_FIELDS,
  GET_TIMESLOTS_FROM_STATE,
  HANDLE_TERRITORY_STATUSES,
  SAVE_PARKMAN_DIRECTION,
  SAVE_PARKMAN_TABLE_FIELDS,
  SET_IS_LOADING_CALL_DRIVER,
  SET_IS_LOADING_TIMESLOTS,
  SET_PARKMAN_DETACH_REASONS,
  SET_PARKMAN_DIRECTION,
  SET_PARKMAN_TABLE_FIELDS,
  SET_TIMESLOTS,
  TO_STATUS_ARRIVED,
  TO_STATUS_DETACH,
} from '@/views/parkman/store/actions'
import { defaultParkmanFields } from '@/views/parkman/data/constants'
import {
  getParkmanDirection,
  getParkmanTableColumns,
  setParkmanDirection,
  setParkmanTableColumns,
} from '@/core'
import API from '@/api'

export default {
  state: {
    timeslots: [],
    isLoading: true,
    isLoadingCallDriver: false,
    parkmanTableColumns: getParkmanTableColumns() || defaultParkmanFields,
    detachReasons: [],
    parkmanDirection: getParkmanDirection() || null,
  },
  getters: {
    [GET_TIMESLOTS_FROM_STATE]: state => state.timeslots,
    [GET_IS_LOADING_TIMESLOTS]: state => state.isLoading,
    [GET_IS_LOADING_CALL_DRIVER]: state => state.isLoadingCallDriver,
    [GET_PARKMAN_TABLE_FIELDS]: state => state.parkmanTableColumns,
    [GET_PARKMAN_DETACH_REASONS]: state => state.detachReasons,
    [GET_PARKMAN_DIRECTION]: state => state.parkmanDirection,
  },
  actions: {
    [FETCH_TIMESLOTS]({ commit, rootGetters, getters }) {
      commit(SET_IS_LOADING_TIMESLOTS, true)

      const params = {
        unload_id: rootGetters[actionsCommon.GET_TERMINAL_CURRENT_ID] || null,
        route_id: getters[GET_PARKMAN_DIRECTION],
      }

      API.timeslots
        .getParkman(params)
        .then(({ data }) => commit(SET_TIMESLOTS, data))
        .catch(error => console.log('error', error))
        .finally(() => commit(SET_IS_LOADING_TIMESLOTS, false))
    },

    [FETCH_DETACH_REASONS]({ commit }) {
      commit(SET_IS_LOADING_TIMESLOTS, true)

      API.timeslots
        .getParkmanDetachReasons()
        .then(({ data }) => commit(SET_PARKMAN_DETACH_REASONS, data))
        .catch(error => console.log('error', error))
        .finally(() => commit(SET_IS_LOADING_TIMESLOTS, false))
    },

    [TO_STATUS_ARRIVED]({ commit, dispatch }, timeslot_id) {
      commit(SET_IS_LOADING_CALL_DRIVER, true)

      API.timeslots
        .toStatusArrived(timeslot_id)
        .then(() => dispatch(FETCH_TIMESLOTS))
        .catch(error => console.log('error', error))
        .finally(() => commit(SET_IS_LOADING_CALL_DRIVER, false))
    },
    [HANDLE_TERRITORY_STATUSES]({ commit, dispatch }, data) {
      commit(SET_IS_LOADING_TIMESLOTS, true)

      API.timeslots
        .changeTimeslotStatus(data)
        .then(() => dispatch(FETCH_TIMESLOTS))
        .catch(error => console.log('error', error))
        .finally(() => commit(SET_IS_LOADING_TIMESLOTS, false))
    },
    [TO_STATUS_DETACH]({ commit, dispatch }, payload) {
      commit(SET_IS_LOADING_CALL_DRIVER, true)

      return API.timeslots
        .setDetachTimeslot(payload)
        .then(() => dispatch(FETCH_TIMESLOTS))
        .catch(error => console.log('error', error))
        .finally(() => commit(SET_IS_LOADING_CALL_DRIVER, false))
    },
    [SAVE_PARKMAN_TABLE_FIELDS]({ commit }, payload) {
      setParkmanTableColumns(payload)
      commit(SET_PARKMAN_TABLE_FIELDS, payload)
    },
    [SAVE_PARKMAN_DIRECTION]({ commit, dispatch }, payload) {
      setParkmanDirection(payload)
      commit(SET_PARKMAN_DIRECTION, payload)
      dispatch(FETCH_TIMESLOTS)
    },
  },
  mutations: {
    [SET_TIMESLOTS](state, payload) {
      state.timeslots = payload
    },
    [SET_IS_LOADING_TIMESLOTS](state, payload) {
      state.isLoading = payload
    },
    [SET_IS_LOADING_CALL_DRIVER](state, payload) {
      state.isLoadingCallDriver = payload
    },
    [SET_PARKMAN_TABLE_FIELDS](state, payload) {
      state.parkmanTableColumns = payload
    },
    [SET_PARKMAN_DETACH_REASONS](state, payload) {
      state.detachReasons = payload
    },
    [SET_PARKMAN_DIRECTION](state, payload) {
      state.parkmanDirection = payload
    },
  },
}
